import { WrapComponentVisibility } from 'src/themes/shared/containers/WrapComponentVisibility';
import { ComponentsName } from 'src/interfaces/enums';
import TextOverflow from '../TextOverflow';
import styles from './styles.module.scss';

export interface ITitleProps {
  children: string;
}

const Title = ({ children }: ITitleProps) => {
  return (
    <WrapComponentVisibility componentName={ComponentsName.mediaTitle}>
      <TextOverflow className={styles.title} asComponent='h1'>
        {children}
      </TextOverflow>
    </WrapComponentVisibility>
  );
};

export default Title;
